var $ = global.jQuery = global.$;
var uiBlock = require('global/ui-block');

var videoTmpl = require('templates/htmlVideo.dot');
var youtubeTmpl = require('templates/youtubeEmbed.dot');

var _Base = require('./_Base');
/**
 * Gallery overlay widget
 * @class
 * @extends _Base
 */
var GalleryOverlay = _Base.extend(
  /** @lends GalleryOverlay.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.items = [];
    this.index = 0;
    this.$itemArea = this.$el.find('[data-gallery-items]');

    this.$close = this.$el.find('[data-overlay-close]');

    this.$close.on('click', function(event) {
      event.preventDefault();
      self.close();
    });

  },
  /**
   * Add an item to the gallery
   * @param {object} item The item object to run through the template and add to the gallery. One of Video or Image property is required
   * @param {string} item.Caption The image/video caption
   * @param {object} [item.Image] An image object
   * @param {string} item.Image.Src The url for the source of the image
   * @param {string} [item.Image.Size] The image size. Only needed if the image will be requestable
   * @param {object} [item.Video] A video object
   * @param {string} item.Video.SrcMp4 The url for the source of the mp4 video
   * @param {string} item.Video.SrcWebm The url for the source of the webm video
   * @returns {number} The item id/index
   */
  addItem: function(item) {
    var itemData = {};
    var tmpl = require('templates/galleryItem.dot');

    item.id = this.index;
    item.html = tmpl(item);
    item.loaded = false;

    this.$itemArea.append(item.html);

    this.items.push(item);

    this.index++;

    return item.id;
  },
  addSourcesToVideo: function(element, video) {
    var sourceWebm = document.createElement('source');
    var sourceMp4 = document.createElement('source');

    sourceWebm.src = video.SrcWebm;
    sourceWebm.type = 'video/webm';
    sourceMp4.src = video.SrcMp4;
    sourceMp4.type = 'video/mp4';

    element.appendChild(sourceWebm);
    element.appendChild(sourceMp4);
  },
  /**
   * Open the gallery at the specified index
   * @param {number} index The index at which to open the gallery overlay
   */
  open: function(index) {
    var children = this.$itemArea.children();
    var child = this.$itemArea.find('[data-id=' + index + ']');
    var self = this;
    var loadContainer = child.find('[data-load]');

    loadContainer.empty();

    children.hide();

    child.velocity('fadeIn');

    this.$el.velocity('fadeIn', {
      complete: function() {
        var img = $('<img>');
        var imgCopy = $('<img>');
        var video = $('<video controls></video>');
        var width = 1000;
        var svg = self.$el.find('svg').eq(0);
        var svgParent = svg.parents().eq(0);
        svg.detach();
        svgParent.append(svg);

        img.on('load', function() {
          var that = this;
          setTimeout(function() {
            $(that).width(width);
            $(that).css('opacity', '1');
          }, 200);
        });

        imgCopy.on('load', function() {
          width = this.width <= 1000 ? this.width : width;
        });

        video.on('loadedmetadata', function() {

          var that = this;
          setTimeout(function() {
            var w = that.videoWidth <= 1000 ? that.videoWidth : width;
            $(that).width(that.videoWidth);
            $(that).css('opacity', '1');
          }, 200);
        });

        if (self.items[index].Video) {
          if (self.items[index].Video.YoutubeUrl && self.items[index].Video.YoutubeUrl !== '') {
            loadContainer.append(youtubeTmpl(self.items[index].Video));
          } else {

            loadContainer.append(video);
            self.addSourcesToVideo(video.get(0),self.items[index].Video);
          }
        } else {
          loadContainer.append(img);
          imgCopy.attr('src', self.items[index].Image.Src);
          imgCopy.attr('alt', self.items[index].Caption);
          img.attr('src', self.items[index].Image.Src);
          img.attr('alt', self.items[index].Caption);
        }

      }
    });

  },
  /**
   * Close the gallery overlay
   */
  close: function() {
    this.$el.velocity('fadeOut');
  },
  /**
   * Remove an item from the gallery
   */
  removeItem: function(index) {
    this.$itemArea.find('[data-id=' + index + ']').remove();
  }
});

module.exports = GalleryOverlay;



/*****************
 ** WEBPACK FOOTER
 ** ./source/scripts/widgets/GalleryOverlay.js
 ** module id = 231
 ** module chunks = 0 1
 **/